import {Base,Axios} from "@/api/Base"

export class MpfDownMpfReportYear extends Base {

    path = "mpf/downMpfReportYear"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}